module.exports = __webpack_public_path__ + "img/local-storage.d855478.webp";